import { FaBullseye, FaEye, FaHeart, FaHandsHelping, FaPeopleArrows, FaAward, FaCalendarAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styles from './About.module.css'

const About = () => {
  const coreValues = [
    {
      icon: FaHandsHelping,
      title: 'Respect',
      description: 'Wij behandelen iedereen met respect en waardigheid. De mening en wensen van onze cliënten staan altijd centraal in onze begeleiding.',
      color: 'primary'
    },
    {
      icon: FaPeopleArrows,
      title: 'Betrokkenheid',
      description: 'We zijn oprecht betrokken bij het welzijn van onze cliënten en hun families. Hun geluk en ontwikkeling zijn onze drijfveer.',
      color: 'secondary'
    },
    {
      icon: FaAward,
      title: 'Professionaliteit',
      description: 'Ons team bestaat uit gekwalificeerde professionals die continu investeren in kennis en vaardigheden om de beste zorg te bieden.',
      color: 'primary'
    },
    {
      icon: FaHeart,
      title: 'Warmte',
      description: 'Een glimlach, een luisterend oor, een vriendelijk woord - bij ons voelt u zich thuis en welkom in een warme, huiselijke omgeving.',
      color: 'secondary'
    }
  ]

  return (
    <div className={styles.aboutPage}>
      {/* Page Header */}
      <section className={styles.pageHeader}>
        <div className="container">
          <h1 className="fade-in">Over SOBE Zorg Twente</h1>
          <p className="fade-in-delay">Professionele zorg met een persoonlijke touch</p>
        </div>
      </section>

      {/* Our Story */}
      <section className={styles.storySection}>
        <div className="container">
          <div className={styles.storyGrid}>
            <div className={`${styles.storyContent} fade-in`}>
              <h2>Ons verhaal</h2>
              <p>
                Sobé Zorg Twente is in 2015 opgericht vanuit de passie om kwalitatieve zorg te bieden 
                aan ouderen die extra ondersteuning nodig hebben. De naam <strong>Sobé</strong> betekent 
                "ouderen" in het Suryoyo, wat onze missie perfect symboliseert. Wat begon als een klein 
                initiatief, is uitgegroeid tot een professionele zorginstelling waar warmte 
                en persoonlijke aandacht centraal staan.
              </p>
              <p>
                Wij zijn gespecialiseerd in de zorg voor <strong>multiculturele cliënten</strong> en bieden 
                een inclusieve omgeving waar iedereen zich thuis voelt, ongeacht achtergrond of 
                cultuur. Ons team van gedreven professionals werkt elke dag met hart en ziel aan 
                het welzijn van onze cliënten.
              </p>
              <p>
                Bij Sobé Zorg Twente draait het niet alleen om zorg verlenen, maar vooral om 
                verbinding maken en samen groeien. Elk individu is uniek en verdient 
                begeleiding die aansluit bij wie hij of zij is.
              </p>
            </div>
            <div className={`${styles.storyImage} fade-in-delay`}>
              <img 
                src="/assets/img/dagbesteding-gebouw.jpg" 
                alt="De dagbesteding locatie van Sobé Zorg Twente in Hengelo"
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src = ''
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className={styles.mvvSection}>
        <div className="container">
          <div className={styles.mvvGrid}>
            <div className={`${styles.mvvCard} fade-in`}>
              <div className={styles.mvvIcon}>
                <FaBullseye aria-hidden="true" />
              </div>
              <h3>Onze Missie</h3>
              <p>
                Het bieden van professionele en warme zorg die aansluit bij de individuele 
                behoeften van onze cliënten. Wij streven naar optimale kwaliteit van leven 
                en maximale zelfstandigheid.
              </p>
            </div>
            
            <div className={`${styles.mvvCard} ${styles.mvvCardSecondary} fade-in-delay`}>
              <div className={styles.mvvIcon}>
                <FaEye aria-hidden="true" />
              </div>
              <h3>Onze Visie</h3>
              <p>
                Een samenleving waarin iedereen mee kan doen en zich gewaardeerd voelt. 
                Wij willen een leidende rol spelen in inclusieve en persoonlijke zorg 
                die echt verschil maakt.
              </p>
            </div>
            
            <div className={`${styles.mvvCard} fade-in-delay`}>
              <div className={styles.mvvIcon}>
                <FaHeart aria-hidden="true" />
              </div>
              <h3>Onze Waarden</h3>
              <p>
                Respect, betrokkenheid, professionaliteit en warmte. Deze kernwaarden 
                vormen de basis van alles wat wij doen en bepalen hoe wij met elkaar 
                en met onze cliënten omgaan.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Detail */}
      <section className={styles.valuesSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h2>Onze kernwaarden in de praktijk</h2>
            <p>Wat ons onderscheidt in de zorg</p>
          </div>
          
          <div className={styles.valuesGrid}>
            {coreValues.map((value, index) => {
              const Icon = value.icon
              return (
                <div key={index} className={styles.valueCard}>
                  <div className={`${styles.valueIcon} ${styles[`valueIcon${value.color.charAt(0).toUpperCase() + value.color.slice(1)}`]}`}>
                    <Icon aria-hidden="true" />
                  </div>
                  <div className={styles.valueContent}>
                    <h3>{value.title}</h3>
                    <p>{value.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <div className="container">
          <h2>Wilt u ons beter leren kennen?</h2>
          <p>Plan een kennismakingsgesprek of kom langs voor een rondleiding</p>
          <Link to="/contact" className={styles.btnPrimary}>
            <FaCalendarAlt aria-hidden="true" /> Maak een afspraak
          </Link>
        </div>
      </section>
    </div>
  )
}

export default About
